import Config from 'react-native-config';

const MANUFACTURER_LINE_SEPARATOR = '|';

export const SOFTWARE_LABEL_ENABLED = Config.SOFTWARE_LABEL_ENABLED === 'true';

export const SOFTWARE_LABEL_SOFTWARE_NAME =
  Config.SOFTWARE_LABEL_SOFTWARE_NAME || '';

export const SOFTWARE_LABEL_NOTIFIED_BODY_NUMBER =
  Config.SOFTWARE_LABEL_NOTIFIED_BODY_NUMBER || '';

export const SOFTWARE_LABEL_DEVICE_NAME =
  Config.SOFTWARE_LABEL_DEVICE_NAME || '';

export const SOFTWARE_LABEL_EIFU_URL = Config.SOFTWARE_LABEL_EIFU_URL || '';

export const SOFTWARE_LABEL_RELEASE_DATE =
  Config.SOFTWARE_LABEL_RELEASE_DATE || '';

export const SOFTWARE_LABEL_MANUFACTURER_LINES = (
  Config.SOFTWARE_LABEL_MANUFACTURER || ''
)
  .split(MANUFACTURER_LINE_SEPARATOR)
  .map(line => line.trim())
  .filter(Boolean);
